module.exports = __webpack_public_path__ + "e84b9748607b23f28705cf343c66c073.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/kz.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/kz.svg
// module chunks = 0